import { Overview, Billing, ProjectList } from '../scenes/dashboard';
import { ComponentType } from 'react';

export type ItemData = {
  title: string;
  scene: ComponentType;
  icon: string;
};

export const clientItems: Array<ItemData> = [
  {
    title: 'Overview',
    scene: Overview,
    icon: 'pieOverview',
  },
  {
    title: 'Billing',
    scene: Billing,
    icon: 'bill',
  },
];

export const pmItems: Array<ItemData> = [
  {
    title: 'Project List',
    scene: ProjectList,
    icon: 'projectList',
  },
];
